// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../covid-dashboard/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".logo[data-v-0f0e5620]{max-width:310px;height:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
